var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarBajasHover68X56(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 56,
    viewBox: "0 0 68 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5699 21.4502C26.7941 21.4502 26.1699 22.0744 26.1699 22.8502V33.1502C26.1699 33.926 26.7941 34.5502 27.5699 34.5502H40.4299C40.4779 34.5502 40.5248 34.5547 40.5703 34.5633C41.2797 34.4934 41.8299 33.8986 41.8299 33.1702V25.1002C41.8299 24.3244 41.2057 23.7002 40.4299 23.7002H33.7699C33.3072 23.7002 32.8803 23.5266 32.5482 23.2277L30.6685 21.538C30.6006 21.4769 30.5272 21.4502 30.4499 21.4502H27.5699ZM40.2571 36.0502H27.5699C25.9657 36.0502 24.6699 34.7544 24.6699 33.1502V22.8502C24.6699 21.246 25.9657 19.9502 27.5699 19.9502H30.4499C30.9124 19.9502 31.3392 20.1237 31.6713 20.4224L33.5513 22.1124C33.6192 22.1735 33.6926 22.2002 33.7699 22.2002H40.4299C42.0341 22.2002 43.3299 23.496 43.3299 25.1002V33.1702C43.3299 34.7744 42.0341 36.0702 40.4299 36.0702C40.3705 36.0702 40.3126 36.0633 40.2571 36.0502Z",
    fill: "#61B09D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8999 32.0702C27.8999 31.656 28.2357 31.3202 28.6499 31.3202H31.6799C32.0941 31.3202 32.4299 31.656 32.4299 32.0702C32.4299 32.4844 32.0941 32.8202 31.6799 32.8202H28.6499C28.2357 32.8202 27.8999 32.4844 27.8999 32.0702Z",
    fill: "#61B09D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBajasHover68X56);
export default __webpack_public_path__ + "static/media/SIDEBAR-BAJAS-HOVER_68X56.6d0aaf3556fa4d3210668fb28b596b0f.svg";
export { ForwardRef as ReactComponent };